<div class="user-profile-detail save-address-detail">
    <div class="address-modal-title">
        <a *ngIf="!webView" (click)="backClick()"><img src="assets/images/back-arrow.svg" alt="arrow" /></a>
        <h4 class="d-lg-none d-block">My Addresses</h4>
    </div>
    <div class="profile-my-address" *ngIf="defaultAddressArray?.length > 0 || mAddressListData?.length > 0">
        <div class="profile-scroll scrollbar">
            <!--For Dedault Address-->
            <div class="my-address-detail" *ngFor="let defaultAddress of defaultAddressArray">
                <div class="left-address-detail">
                    <div class="name">
                        <span>{{defaultAddress.name}}</span>
                        <label *ngIf="defaultAddress.is_default">Default</label>
                    </div>
                    <address> {{defaultAddress.address_line1}}</address>
                    <div class="pincode">{{defaultAddress.city}} - {{defaultAddress.postal_code}}</div>
                    <div class="address-call">{{defaultAddress.contact_number1}}</div>
                </div>
                <div class="right-address-button">
                    <ul>
                        <li><a (click)="addUpdateAddress('edit',defaultAddress)" data-bs-toggle="modal"
                                data-bs-target="#add-update-address"><img src="assets/images/edit-address.svg"
                                    alt="address" /></a></li>
                        <li *ngIf="!defaultAddress.is_default"><a (click)="removeAddress(defaultAddress.id)"><img
                                    src="assets/images/delete-address.svg" alt="delete" /></a></li>
                    </ul>
                </div>
            </div>

            <!--For Not Default Address-->
            <div class="my-address-detail" *ngFor="let normalAddress of mAddressListData">
                <div class="left-address-detail">
                    <div class="name">
                        <span>{{normalAddress.name}}</span>
                    </div>
                    <address> {{normalAddress.address_line1}}</address>
                    <div class="pincode">{{normalAddress.city}} - {{normalAddress.postal_code}}</div>
                    <div class="address-call">{{normalAddress.contact_number1}}</div>
                </div>
                <div class="right-address-button">
                    <ul>
                        <li><a (click)="addUpdateAddress('edit',normalAddress)" data-bs-toggle="modal"
                                data-bs-target="#add-update-address"><img src="assets/images/edit-address.svg"
                                    alt="address" /></a></li>
                        <li *ngIf="!normalAddress.is_default"><a (click)="removeAddress(normalAddress.id)"><img
                                    src="assets/images/delete-address.svg" alt="delete" /></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!--address Empty States start -->
    <div class="order-empty mt-2">
        <div class="empty-text" *ngIf="defaultAddressArray?.length == 0 && mAddressListData?.length == 0">
            <span>You haven’t saved any addresses Yet!</span>
            <small>Add one now for a faster checkout when you shop</small>
        </div>
        <div class="order-btn-shopping" data-bs-toggle="modal" data-bs-target="#add-update-address" type="button"
            (click)="addUpdateAddress('add')">
            <a class="start-shopping-btn">Add new address</a>
        </div>
    </div>

    <!-- address Empty States End  -->
</div>



<div class="modal fade address-detail" id="add-update-address" tabindex="-1" aria-labelledby="addNewAddressLabel"
    aria-hidden="true">
    <app-add-address [addressData]="addressData" [viewForm]="viewForm" [from]="'address'"
        (saveClickAddress)="saveNewAddress($event)"></app-add-address>
</div>

<div class="modal fade new-email-popup-d" id="email-update-profile-address" tabindex="-1" aria-labelledby="emailModalLabel" aria-hidden="true">
    <div class="add-new-address-model">
        <div class="modal-dialog" >
            <div class="modal-content">
                <div class="modal-body">
                    <div class="modal-header py-0 d-lg-flex d-none   justify-content-end">
                        <button class="modal-button" type="button" data-bs-dismiss="modal" aria-label="Close"><img src="/assets/images/close-icon.png" alt="close" (click)="closeModal()"></button>
                    </div>
                    <div class="address-modal-title address-email-text">
                        <h4>Email</h4>
                    </div>
                    <form class="add-new-address-detail" [formGroup]="emailFormgroup" (ngSubmit)="onSubmitEmail()">
                       
                        <div class="add-new-address-detail-input row">
                           
                            <div class="mb-3 col-lg-12 col-md-12 email-text">
                                <label>Email</label>
                                <input type="email" formControlName="email" placeholder="Email">
                                <div *ngIf="f['email'].touched && f['email'].invalid" class="alert alert-danger alert-text">
                                    <div *ngIf="f['email'].errors && f['email'].errors['required']">Email is
                                      required.</div>
                                    <div *ngIf="f['email'].hasError('pattern')">
                                      Email is invalid.
                                    </div>
                                  </div>
                            </div>
                            <ul class="save-and-close new-save-btn d-lg-block d-none">
                                <li><button type="submit" class="save-dark" >Save Details</button></li>
                            </ul>
                        </div>
                        <ul class="save-and-close d-lg-none d-flex">
                            <li><button type="submit" class="save-dark" >Save Details</button></li>
                            <li><button class="cancel-border" data-bs-dismiss="modal" 
                                (click)="closeModal();" aria-label="Close">Cancel</button></li>
                        </ul>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>